<template>
  <button class="flex flex-center preview-rotate" @click.stop="handleChangeRoate">
    <Icon path="preview" name="rotate" />
  </button>
</template>

<script>
import Icon from '@/components/icon'

export default {
  name: 'PreviewRotate',
  components: {
    Icon
  },
  data() {
    return {
      rotate: 0
    }
  },
  watch: {
    rotate(val) {
      this.$emit('change', `${val || -360}deg`)
    }
  },
  mounted() {
    this.$topic.subscribe('preview.reset', this.reset)
  },
  methods: {
    reset() {
      this.rotate = 0
    },
    handleChangeRoate() {
      this.rotate = (this.rotate - 90) % 360
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('~@/styles/var.less');
  .preview-rotate {
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    width: 46px;
    height: 40px;
    border-radius: 13px;
    cursor: pointer;
    user-select: none;
    background: transparent;
    transition: all linear .2s;
    &:hover {
      background-color: rgba(146, 159, 183, 0.5);
    }
    .i-icon-rotate {
      font-size: 30px;
    }
  }
  @media screen and (max-width: 768px) {
    .preview-rotate {
      width: 26px;
      margin: 0 8px;
      &:hover {
        background-color: transparent;
      }
    }
  }
</style>